module.exports = __webpack_public_path__ + "static/media/ball-pile.1354df2a.svg";